import '../scss/ta.scss';
import menuModule from "./modules/menu.js";
import faqModule from "./modules/faqModule.js";
import scrollUpModule from "./modules/scrollUpModule.js";
import footerModule from "./modules/footerModule.js";
import terminDescModule from "./modules/terminDescModule.js";
import mobileTableWidthSync from "./modules/mobileTableWidthSync.js";
import baguetteBox from 'baguettebox.js';
import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';

(function ($) {
    $(document).ready(async function () {
        window.$ = jQuery;

        menuModule.init();
        faqModule.init();
        scrollUpModule.init();
        footerModule.init();
        terminDescModule.init();
        mobileTableWidthSync.init();

        // Swiper-ы
        $('.posts-swiper').each(function (i, el) {
            console.log(el.dataset.swiperIndex);

            new Swiper(this, {
                modules: [Navigation],
                slidesPerView: 3,
                spaceBetween: 30,
                navigation: {
                    nextEl: '.button-next-' + el.dataset.swiperIndex,
                    prevEl: '.button-prev-' + el.dataset.swiperIndex,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                    },
                    576: {
                        slidesPerView: 2,
                    },
                    992: {
                        slidesPerView: 3,
                    }
                }
            });
        })

        baguetteBox.run('.lightbox');

        $('[data-disclaimer-btn]').click(e => {
            e.preventDefault();
            $(e.target).closest('.disclaimer').toggleClass('disclaimer-open');
        });

        $('[data-hidden-rows-btn]').click(e => {
            e.preventDefault();
            $(e.target).closest('.hidden-rows').toggleClass('hidden-rows-open');
        });


        // Добавляем таблицам отзывчивости
        const tables = $('table');

        tables.each(function (tableIndex, table) {
            if (!$(table).closest('.table-responsive').length) {
                $(table).wrap('<div class="table-responsive"></div>')
            }
        })

        const syncTableScrollX = () => {
            const isMobile = window.innerWidth < 768;

            $('.table-responsive').each(function () {
                const $wrapper = $(this);
                const $scrollX = $wrapper.children('.table-responsive__scroll-x');
                const $table = $wrapper.children('table, .table_style');

                if (isMobile) {
                    if (!$scrollX.length && $table.length) {
                        $table.wrapAll('<div class="table-responsive__scroll-x"></div>');
                    }

                    const scrollXEl = $wrapper.children('.table-responsive__scroll-x')[0];
                    $wrapper.toggleClass('table-responsive--has-scroll-x', !!scrollXEl && scrollXEl.scrollWidth > scrollXEl.clientWidth + 1);
                } else {
                    if ($scrollX.length) {
                        $scrollX.children().unwrap();
                    }

                    $wrapper.removeClass('table-responsive--has-scroll-x');
                }
            });
        };

        syncTableScrollX();
        $(window).on('resize', syncTableScrollX);

        ////////// Фильтры //////////
        let timeFrame = '15m';
        let dataByTimeFrames = {};

        //Селект открыть/закрыть
        $('[data-filter-toggle]').click(function () {
            const selector = $(this).closest('[data-filter]')[0];
            $(selector).toggleClass('open')

            $(`.filter-inputs-item:not([data-filter="${selector.dataset.filter}"])`).removeClass('open')
        });

        //Событие на выбор/снятие чекбокса
        $('.ta-filters input').change(function (e) {
            // Надо запускать ререндер значение в селектах суммарных
            onFilterChange();
        })

        // Если выбрали новый таймфрейм
        $('[data-timeframe]').click(function () {
            $('.timeframe').removeClass('selected');
            $(this).addClass('selected')

            timeFrame = $(this).data('timeframe');

            renderTable();
        })

        //Событие на отправку формы фильтра
        // $('#ta-filter-submit').click(function (e) {
        //     onFilterSubmit();
        // })

        // Событие сброса
        $('#ta-filter-reset').click(function (e) {
            timeFrame = '15m';
            $('.ta-filters input').prop('checked', false)
            $('[data-timeframe="15m"]').click();

            onFilterChange();
            // onFilterSubmit();
        })

        $(document).click(function (e) {
            const isFilter = $(e.target).closest('.ta-filters-item').length;

            if (!isFilter) {
                $('.filter-inputs-item').removeClass('open')
            }

            const isGoTo = $(e.target).closest('[data-go-to]');

            if(isGoTo.length) {
                e.preventDefault();
                location.href = isGoTo[0].dataset.goTo;
            }
        })


        const renderUpdateDate = (date = null) => {
            const dateEl = $('[data-update-date]');

            if(!date) {
                date = dateEl.data('updateDate');
            }

            const offset = -new Date(date + 'Z').getTimezoneOffset() / 60;

            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const localDate = (new Date(date + 'Z')).toLocaleTimeString('ru-RU', {
                timeZone,
                hour: '2-digit',
                minute: '2-digit',
            }) + ` UTC${offset >= 0 ? '+' : ''}${offset}`;

            dateEl.text(localDate)
        }

        const getFilters = () => {
            const summary = $('[name="summary"]:checked').map((i, el) => el.dataset.text).get();
            const oscillators = $('[name="oscillators"]:checked').map((i, el) => el.dataset.text).get();
            const movingAverages = $('[name="moving_averages"]:checked').map((i, el) => el.dataset.text).get();

            return {summary, oscillators, movingAverages}
        }

        const onFilterChange = () => {
            const {summary, oscillators, movingAverages} = getFilters();

            const $summaryPlaceholderEl = $('[data-placeholder="summary"]');
            const $oscillatorsPlaceholderEl = $('[data-placeholder="oscillators"]');
            const $movingAveragesPlaceholderEl = $('[data-placeholder="moving_averages"]');

            $summaryPlaceholderEl.text(summary.join(', ') || $summaryPlaceholderEl.data('placeholderDefault'))
            $oscillatorsPlaceholderEl.text(oscillators.join(', ') || $oscillatorsPlaceholderEl.data('placeholderDefault'))
            $movingAveragesPlaceholderEl.text(movingAverages.join(', ') || $movingAveragesPlaceholderEl.data('placeholderDefault'))

            renderTable();
        }

        const fetchData = async () => {
            const {data} = await $.post(ajaxurl, {action: 'getTaTable', timeFrame});
            dataByTimeFrames = data;
        }

        const renderTable = () => {
            if (dataByTimeFrames[timeFrame] === undefined) {
                return false;
            }

            const filters = {...getFilters()};

            let html = '';

            renderUpdateDate(dataByTimeFrames[timeFrame].updateDate);

            dataByTimeFrames[timeFrame].items
                .filter(row => {
                    if(!filters) return true;

                    if(filters.summary.length && !filters.summary.includes(row.summary)) {
                        return false;
                    }
                    if(filters.oscillators.length && !filters.oscillators.includes(row.oscillators)) {
                        return false;
                    }
                    if(filters.movingAverages.length && !filters.movingAverages.includes(row.movingAverages)) {
                        return false;
                    }

                    return true;
                })
                .forEach((row, index) => {
                    html += `
                        <tr data-go-to="${row.url}">
                            <td>${index + 1}</td>
                            <td >
                                <a href="${row.url}" class="coin">
                                    <img class="coin-image" src="${row.thumb_url}" alt="">
                                    <span>${row.title} <span>${row.coin}</span></span>
                                </a>                            
                            </td>
                            <td>
                                <div class="ta-badge ${row.summaryBadge}">${row.summary}</div>
                            </td>
                            <td>
                                <div class="ta-badge ${row.movingAveragesBadge}">${row.movingAverages}</div>
                            </td>
                            <td>
                                <div class="ta-badge ${row.oscillatorsBadge}">${row.oscillators}</div>
                            </td>
                        </tr>
                        `;
                })

            $('#ta-table-body').html(html)
        }

        await fetchData();
        renderTable();
        mobileTableWidthSync.sync();

        setInterval(async () => {
            await fetchData();
            renderTable();
            mobileTableWidthSync.sync();
        }, 10000)
    });
}(jQuery));

